﻿/**
 * 艾斯达 Asstar 官网静态内容数据层 v4
 * 内容来源：
 *  - 产品：iot.asstar.com 产品列表接口（动态获取）
 *  - 星选商城：api.asstar.com 推荐商品接口（动态获取）
 *  - 解决方案/技术实力/关于我们：《北京艾斯达科技有限公司介绍.pptx》
 */

/* ---------- 首页数据指标 ---------- */
export const homeStats = [
  { num: "120万+", label: "接入设备数" },
  { num: "500+", label: "企业客户" },
  { num: "2亿+", label: "日均数据点处理" },
  { num: "99.99%", label: "平台可用性" }
];

/* ---------- 产品与服务：全部产品（来源：iot.asstar.com，动态获取） ---------- */
export const productCategories = ["全部"];

export const products = [];

/* 产品分类 ID → 名称映射 */
var productCategoryMap = {
  1: "智能灯",
  2: "宠物用品",
  3: "小家电",
  4: "运动",
  5: "安防",
  6: "地球仪",
  7: "大家电",
  8: "智能家居",
  9: "跑步",
  10: "玩具"
};

/* 去除 Summary 中的 HTML 标签 */
function stripHtml(str) {
  return String(str || "").replace(/<[^>]*>/g, "").trim();
}

/* 拉取产品列表（该接口仅支持 POST + JSON Body），按更新时间倒序 */
fetch("https://iot.asstar.com/api/product/list", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ Pager: { PageNumber: 1, PageSize: 200 } })
})
  .then(function (res) { return res.json(); })
  .then(function (res) {
    var list = (res.Data && res.Data.Results) || [];
    list.sort(function (a, b) {
      return String(b.UpdateTime || "").localeCompare(String(a.UpdateTime || ""));
    });
    var mapped = list.map(function (p) {
      return {
        id: p.ID,
        name: p.Name,
        category: productCategoryMap[p.CategoryID] || "其他",
        firmware: p.FirmwareQTY || 0,
        desc: stripHtml(p.Summary),
        tag: "",
        image: p.ImageUrl || ""
      };
    });
    products.splice.apply(products, [0, products.length].concat(mapped));

    /* 分类筛选页签按实际数据推导 */
    var cats = [];
    mapped.forEach(function (p) {
      if (p.category && cats.indexOf(p.category) < 0) cats.push(p.category);
    });
    productCategories.splice.apply(productCategories, [0, productCategories.length].concat(["全部"], cats));
  })
  .catch(function (e) {
    console.error("产品列表加载失败", e);
  });

/* ---------- 服务（产品与服务下拉第二组） ---------- */
export const serviceCards = [
  {
    name: "AIOT 服务",
    en: "AIoT Services",
    image: "/images/illus/illus-aiot.jpg",
    desc: "设备接入、云平台搭建、智慧行业系统与定制开发，打通「硬件—云端—应用—生态」闭环。",
    points: ["设备全生命周期管理", "IoT 数据中台与规则引擎", "智慧行业系统落地"],
    to: "/service/aiot.html"
  },
  {
    name: "大模型服务",
    en: "LLM Services",
    image: "/images/illus/illus-llm.jpg",
    desc: "模型私有化部署、企业知识库、智能体工作流与数据服务，让业务系统快速获得 AI 能力。",
    points: ["私有化部署与国产算力兼容", "RAG 企业知识库问答", "智能体工作流自动化"],
    to: "/service/llm.html"
  }
];

/* ---------- AIOT 服务 ---------- */
export const aiotServices = [
  {
    name: "设备接入与运维服务",
    desc: "从协议调研、设备选型到批量接入与后期运维，帮助企业快速把存量设备搬上云。",
    points: ["协议适配与采集调试", "设备台账与数字孪生建档", "7×24 远程运维托管"]
  },
  {
    name: "物联网产品及解决方案",
    desc: "RFID 全场景方案与 GNSS / 北斗定位方案，实现「一物一芯、全程可溯」与精准信息化管理。",
    points: ["RFID 标签、读写器及密钥发行器", "珠宝防伪溯源与资产管理", "厘米级/亚米级定位模块与平台"]
  },
  {
    name: "智能硬件定制服务",
    desc: "BearPi 开发板与核心模组验证平台，WiFi / BLE / BLE Mesh 模组选型，AIoT 终端快速量产。",
    points: ["配套 SDK、开发文档与技术支持", "AI 对话玩具、转写翻译录音笔", "全屋智能开关插座、AI 语音地球仪"]
  },
  {
    name: "全场景智慧行业系统",
    desc: "将 AI 算法与行业场景深度融合，为农牧、珠宝、生态等行业提供全链路数字化系统。",
    points: ["轩辕农牧云：养殖/防疫/溯源", "珠宝检测平台：证书/溯源", "生态监测系统：预警/治理"]
  }
];

export const aiotProcess = [
  { step: "01", name: "需求咨询", desc: "现场调研业务场景，输出评估报告与建设路径" },
  { step: "02", name: "方案设计", desc: "架构师输出整体方案与 POC 验证计划" },
  { step: "03", name: "交付实施", desc: "分阶段交付上线，双周迭代同步进度" },
  { step: "04", name: "持续运维", desc: "SLA 保障 + 专属客户成功团队陪跑" }
];

/* AIOT 服务配图 */
var aiotServiceImages = [
  "illus-iot.jpg", "case-beidou.jpg", "illus-hardware.jpg", "illus-industry.jpg"
];
aiotServices.forEach(function (s, i) {
  s.image = "/images/illus/" + aiotServiceImages[i];
});

/* ---------- 大模型服务 ---------- */
export const llmServices = [
  {
    name: "模型私有化部署",
    desc: "在企业自有算力或私有云内部署开源大模型，数据全程不出域，满足合规要求。",
    points: ["主流开源模型选型与适配", "国产化算力（昇腾/海光）兼容", "推理性能调优与弹性扩缩容"]
  },
  {
    name: "企业知识库问答",
    desc: "基于 RAG 检索增强技术，把制度文档、技术手册、工单沉淀为可对话的企业大脑。",
    points: ["多格式文档智能解析", "答案溯源与权限隔离", "对话质量持续评测优化"]
  },
  {
    name: "智能客服升级",
    desc: "以大模型重构客服机器人，意图理解更准确，复杂问题可无缝转人工。",
    points: ["多轮对话与上下文记忆", "与工单/CRM 系统集成", "满意度与解决率看板"]
  },
  {
    name: "智能体（Agent）工作流",
    desc: "把报表生成、巡检报告、审批摘要等重复性工作交给智能体自动完成。",
    points: ["工具调用与流程编排", "人机协同审批节点", "执行日志全程可审计"]
  },
  {
    name: "数据与 AI 服务",
    desc: "专业的数据清洗标注、AI 模型训练微调、智驾路测数据采集等一站式数据服务。",
    points: ["语料清洗与标注指导", "LoRA 轻量化微调", "智驾路测数据采集"]
  },
  {
    name: "AI 应用咨询陪跑",
    desc: "从场景盘点到落地路线图，陪企业走稳大模型落地第一步。",
    points: ["高价值场景盘点", "投入产出（ROI）测算", "落地路线图与里程碑"]
  }
];

/* 大模型服务配图 */
var llmServiceImages = [
  "illus-llmhub.jpg", "illus-llm.jpg", "illus-app.jpg", "illus-sdk.jpg", "illus-cloud.jpg", "illus-industry.jpg"
];
llmServices.forEach(function (s, i) {
  s.image = "/images/illus/" + llmServiceImages[i];
});

/* ---------- 解决方案（来源：PPT 核心业务板块） ---------- */
export const solutionPillars = [
  {
    name: "智能硬件研发",
    desc: "专注高性能嵌入式模组与工业控制终端的定制化开发，提供稳定可靠的硬件底座。",
    icon: "chip",
    image: "/images/illus/illus-hardware.jpg"
  },
  {
    name: "行业解决方案",
    desc: "深度融合 AI 算法与行业场景，为制造、物流等领域提供全链路数字化转型方案。",
    icon: "grid",
    image: "/images/illus/illus-industry.jpg"
  },
  {
    name: "云服务平台",
    desc: "构建高可用、弹性扩展的 IoT 数据中台，实现设备的实时监控与远程管理。",
    icon: "cloud",
    image: "/images/illus/illus-cloud.jpg"
  }
];

export const solutionGroups = [
  {
    name: "物联网产品及解决方案",
    slogan: "连接万物，感知世界",
    items: [
      {
        name: "RFID 全场景方案",
        desc: "提供高频/超高频标签、读写器及密钥发行器，广泛应用于珠宝防伪溯源、资产管理等场景，实现「一物一芯、全程可溯」。"
      },
      {
        name: "GNSS / 北斗定位方案",
        desc: "提供厘米级/亚米级定位模块、终端及平台，深度赋能车载导航、智慧巡检、电网监测等场景，实现人员与车辆的精准信息化管理。"
      }
    ]
  },
  {
    name: "智能硬件定制",
    slogan: "快速量产 · 全方位赋能 AIoT 终端产品",
    items: [
      {
        name: "BearPi 开发板与通用模组",
        desc: "核心模组与硬件验证平台，提供 WiFi / BLE / BLE Mesh 等多种主流无线通信模组选型，配套完善的 SDK、开发文档与技术支持。"
      },
      {
        name: "AIoT 终端产品定制落地",
        desc: "智能交互：AI 对话玩具、实时转写翻译录音笔；智能控制：全屋智能开关、远程控制智能插座；智能教育：AI 语音视听地球仪、互动学习机。"
      }
    ]
  },
  {
    name: "AI 与软件产品解决方案",
    slogan: "融智于云，赋能行业",
    items: [
      {
        name: "AIoT 基础能力平台",
        desc: "设备全生命周期管理、海量时序数据存储、AI 模型训练推理及标准化开放 API，构建稳固技术底座，赋能生态合作伙伴。"
      },
      {
        name: "全场景智慧行业系统",
        desc: "轩辕农牧云（养殖/防疫/溯源）｜珠宝检测平台（证书/溯源）｜生态监测系统（预警/治理）｜资产全维管理（RFID/二维码）。"
      }
    ]
  },
  {
    name: "AR 交互与可视化",
    slogan: "虚实融合，身临其境",
    items: [
      {
        name: "AR 虚拟现实",
        desc: "提供 AR 远程协助、AR 导航、AR 营销等解决方案，打破物理空间限制，实现即时交互。"
      },
      {
        name: "数字孪生构建",
        desc: "构建城市、园区、矿山等场景的高精度数字孪生模型，实现物理世界与数字世界的实时映射与智能管控。"
      },
      {
        name: "三维可视化平台",
        desc: "将复杂的数据报表和业务流程转化为直观的三维动态图形，帮助管理者快速洞察数据，大幅提升决策效率。"
      }
    ]
  },
  {
    name: "ITO / 信息技术外包服务",
    slogan: "专业团队，灵活支持",
    items: [
      { name: "软件开发", desc: "驻场或远程提供高质量开发服务，覆盖 Java、Python 等多种主流技术栈。" },
      { name: "ODC 共建", desc: "与客户共建离岸开发中心，提供稳定、高效、专属的长期技术研发团队。" },
      { name: "测试运维", desc: "全链路软件测试、7×24 小时系统运维及技术支持，保障业务稳定运行。" },
      { name: "数据与 AI 服务", desc: "数据清洗标注、AI 模型训练微调、智驾路测数据采集等一站式数据服务。" },
      { name: "客服与呼叫中心", desc: "多渠道客服外包、智能呼叫中心搭建及运营解决方案，提升客户服务满意度。" }
    ]
  }
];

export const cases = [
  {
    name: "珠宝行业",
    image: "/images/illus/case-jewelry.jpg",
    desc: "国首检测珠宝送检小程序，RFID 防伪溯源系统全链路追踪",
    tag: "防伪溯源"
  },
  {
    name: "智慧畜牧",
    image: "/images/illus/case-livestock.jpg",
    desc: "庆阳市动物智慧化防疫平台，甘肃锦恒佳牧智慧养殖系统",
    tag: "农牧云"
  },
  {
    name: "高端防伪",
    image: "/images/illus/case-security.jpg",
    desc: "高端白酒国密 RFID / 艺术品鉴证，营业执照 NFC 芯片防伪认证",
    tag: "国密芯片"
  },
  {
    name: "AIoT 智能消费终端",
    image: "/images/illus/case-consumer.jpg",
    desc: "AI 多轮对话智能教育玩具、支持实时转写与翻译的专业级 AI 智能录音笔",
    tag: "消费终端"
  }
];

/* ---------- 联系方式（来源：www.asstar.com 关于我们） ---------- */
export const contactInfo = {
  address: "北京市昌平区东小口镇天通中苑二区21号楼2层1578号",
  hotline: "13436872189",
  hotlineTime: "9:00-20:00",
  qrcode: "/images/qrcode1.png",
  qrcodeLabel: "微信联系",
  emails: [
    { label: "商务合作", value: "dsswater123@outlook.com" },
    { label: "市场公关", value: "dsswater123@outlook.com" }
  ]
};

/* ---------- 技术与支持（来源：PPT 技术实力 + upgrader 升级台） ---------- */
export const techPlatforms = [
  {
    name: "AIoT 云平台",
    image: "/images/illus/illus-iot.jpg",
    desc: "提供设备接入、数据管理、规则引擎与可视化等核心能力，支撑海量设备稳定在线。",
    points: ["设备接入与管理", "规则引擎与可视化", "海量时序数据存储"]
  },
  {
    name: "AI 大模型中台",
    image: "/images/illus/illus-llmhub.jpg",
    desc: "集成多种 AI 算法，支持模型训练、部署和推理，深度赋能上层应用。",
    points: ["多模型统一管理", "训练/部署/推理一体化", "开放标准化 API"]
  },
  {
    name: "通用开发套件",
    image: "/images/illus/illus-sdk.jpg",
    desc: "提供完善的软硬件 SDK，极大缩短产品开发与验证周期。",
    points: ["BearPi 硬件验证平台", "WiFi / BLE / BLE Mesh 模组", "SDK 与开发文档"]
  },
  {
    name: "配网控制 APP",
    image: "/images/illus/illus-app.jpg",
    desc: "实现智能设备的一键快速配网与全功能远程控制管理。",
    points: ["一键快速配网", "全功能远程控制", "设备状态实时同步"]
  }
];

export const techSupports = [
  {
    name: "在线固件升级台",
    image: "/images/illus/sup-upgrade.jpg",
    desc: "按设备选择固件，查看版本历史，浏览器直连串口完成烧录，无需安装任何桌面工具。",
    href: "https://upgrader.asstar.com/",
    linkText: "进入固件升级台"
  },
  {
    name: "设备互联平台",
    image: "/images/illus/sup-miot.jpg",
    desc: "星达智联设备管理入口，智能设备配网、场景配置与远程控制一站式完成。",
    href: "https://miot.asstar.com/iot/light",
    linkText: "进入智联平台"
  },
  {
    name: "APP 下载",
    image: "/images/illus/sup-download.jpg",
    desc: "星达 APP，运动 × 潮流 × 装备 × 团购，iOS / Android 双端支持。",
    href: "https://www.asstar.com/download.html",
    linkText: "前往下载页"
  },
  {
    name: "开发文档与 SDK",
    image: "/images/illus/illus-sdk.jpg",
    desc: "配套完善的软硬件 SDK 与开发文档，大幅降低开发门槛，缩短产品验证周期。",
    href: "/solutions.html",
    linkText: "查看开发方案"
  },
  {
    name: "专属技术支持",
    image: "/images/illus/illus-aiot.jpg",
    desc: "7×24 小时客户成功团队陪跑，SLA 保障，从需求梳理到上线运维的闭环服务。",
    href: "/about.html",
    linkText: "联系我们"
  },
  {
    name: "生态合作计划",
    image: "/images/illus/illus-industry.jpg",
    desc: "技术授权、API 对接、联合开发、产品定制、品牌联合推广与联合运营多种模式。",
    href: "/about.html",
    linkText: "了解合作模式"
  }
];

export const cooperationModes = [
  { name: "灵活合作模式", desc: "支持技术授权、API 对接、联合开发、产品定制、品牌联合推广及联合运营等多种模式。" },
  { name: "清晰的收益模式", desc: "包含 AI 服务收费、定制开发费、硬件销售利润、平台接口费及第三方入驻分成，收益结构透明。" },
  { name: "全流程交付保障", desc: "从需求梳理到上线运维提供闭环服务，显著降低客户落地成本与项目周期。" }
];

/* ---------- 星选商城（来源：api.asstar.com，动态获取） ---------- */
export const mallCategories = ["全部"];

export const mallItems = [];

/* 拉取商城分类与推荐商品；SaleCategoryIDs 为 ",40,33," 格式，映射为分类名数组 */
fetch("https://api.asstar.com/api/product/SaleCategory")
  .then(function (res) { return res.json(); })
  .then(function (catRes) {
    var catList = catRes.Data || [];
    var catMap = {};
    catList.forEach(function (c) { catMap[c.ID] = c.Name; });
    mallCategories.splice.apply(mallCategories, [0, mallCategories.length].concat(["全部"], catList.map(function (c) { return c.Name; })));

    return fetch("https://api.asstar.com/api/product/recommendlist", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Pager: { PageNumber: 1, PageSize: 200 } })
    })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        var list = (res.Data && res.Data.Results) || [];
        var mapped = list.map(function (g) {
          return {
            id: g.ID,
            name: g.Title,
            category: String(g.SaleCategoryIDs || "").split(",").filter(function (id) { return id && catMap[id]; }).map(function (id) { return catMap[id]; }),
            price: g.Price,
            desc: "",
            sales: g.SalesVolume || 0,
            tag: "",
            image: g.ImageUrl || ""
          };
        });
        mallItems.splice.apply(mallItems, [0, mallItems.length].concat(mapped));
      });
  })
  .catch(function (e) {
    console.error("商城商品加载失败", e);
  });

/* ---------- 关于我们（来源：PPT） ---------- */
export const aboutIntro = "（ASSTAR）是一家专注于物联网、人工智能、AR 交互及智能硬件定制的全栈式科技企业。致力于打通「硬件—云端—应用—生态」闭环，为客户提供从研发到落地的一体化数智化解决方案。";

export const values = [
  { name: "创新驱动", desc: "持续投入研发资源，始终引领行业技术前沿。" },
  { name: "客户至上", desc: "深度理解业务需求，提供全周期的优质服务。" },
  { name: "共生共荣", desc: "全力赋能合作伙伴，携手实现业务共同成长。" },
  { name: "务实笃行", desc: "脚踏实地精益求精，确保项目成功交付落地。" }
];

export const culture = [
  {
    name: "使命",
    en: "OUR MISSION",
    desc: "融汇物联网、互联网与人工智能技术，打破数据孤岛，为细分行业客户提供全栈式解决方案，助力其实现数字化转型，共同开创数智融合的未来。"
  },
  {
    name: "愿景",
    en: "OUR VISION",
    desc: "坚持以硬件筑基、云端融智、生态赋能为核心战略，致力于让智能科技深度渗透并赋能千行百业，持续创新，最终成为全球客户最值得信赖的 AIoT 生态合作伙伴。"
  }
];

/* ---------- 首页行业板块（取自典型案例） ---------- */
export const industries = [
  {
    name: "智慧畜牧",
    image: "/images/illus/case-livestock.jpg",
    desc: "动物智慧化防疫平台与智慧养殖系统，防疫溯源全链路数字化"
  },
  {
    name: "珠宝防伪",
    image: "/images/illus/case-jewelry.jpg",
    desc: "国首检测送检小程序 + RFID 防伪溯源，一物一芯全程可溯"
  },
  {
    name: "北斗巡检",
    image: "/images/illus/case-beidou.jpg",
    desc: "三峡大坝智慧巡检、电网杆塔监测与铁路机车高精度定位"
  },
  {
    name: "高端防伪",
    image: "/images/illus/case-security.jpg",
    desc: "高端白酒国密 RFID、艺术品鉴证与营业执照 NFC 芯片防伪"
  },
  {
    name: "智能教育",
    image: "/images/products/p7.jpeg",
    desc: "AI 地球仪、点读笔与互动学习机，沉浸式启蒙学习体验"
  },
  {
    name: "AIoT 消费终端",
    image: "/images/products/p5.jpeg",
    desc: "AI 多轮对话智能教育玩具与实时转写翻译的专业级录音笔"
  }
];
